// 1 day in milliseconds
export const SESSION_TIMEOUT_TIME = 86400000;
